// extracted by mini-css-extract-plugin
export default {"modal":"ModalConfirmAction_modal__eovHW","btn-main":"ModalConfirmAction_btn-main__6+Ksf","btn-cancel":"ModalConfirmAction_btn-cancel__pxJQ3"};